import React from 'react';
import Form from "react-bootstrap/Form";

const PasswordForm = ({fields, handleFieldChange, emailMismatchMessage, messages}) => {
  return (
    <>
      <h3>確認コード入力</h3>
      <p>登録メールアドレスに確認コードを送信いたしました。メールに記載の確認コードを入力してください。</p>
      <p>※ピリオドやスペースは入力しないで６桁の数字のみを入力してください。</p>
      <dl>
        <dt>確認コード<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="confirmationCode" size="lg">
            <Form.Control
              type="text"
              name="confirmationCode"
              value={fields.confirmationCode}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="confirmationCodeMessage" className="errorMessages">{messages.confirmationCode.n}</p>
        </dd>
      </dl>
    </>
  );
}

export default PasswordForm;
